import React from 'react';
import PropTypes from 'prop-types';

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, checked, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <div style={ { width: '100%', height: '100%' } }>
        <input type="checkbox" ref={ resolvedRef } { ...rest } checked={ checked } />
      </div>
    );
  }
);

IndeterminateCheckbox.propTypes = {
  indeterminate: PropTypes.bool,
  checked: PropTypes.bool
};

IndeterminateCheckbox.defaultProps = {
  indeterminate: false,
  checked: false
};

export default IndeterminateCheckbox;
